<template lang="pug">
    .ViewPlanButton(@click="showDialog = true")
        v-layout(row)
            v-flex(xs2)
                v-badge.ViewPlanButton-badge(color="#e90606" overlap v-model="currentStep.data.products.length > 0")
                    template(v-slot:badge)
                        span {{ currentStep.data.products.length }}
                    v-avatar.elevation-7(:size="55")
                        img(src="@/assets/TPV-L1-6-Pagina2 Z.png" alt="Ver plan de vida")        
            v-flex(xs10)
                .ViewPlanButton-button-title Ver mi plan
                .ViewPlanButton-button-text Tienes {{ currentStep.data.products.length }} producto(s)
        v-dialog(v-model="showDialog" persistent  max-width="1000px" )
            v-layout(row, justify-center)
              v-flex(text-xs-center)
                v-card
                    v-layout
                        v-flex
                            img.dialog_img(src="@/assets/TPV-L1-6-Pagina2 E.png")
                    v-spacer.my-2.py-4
                    v-card-text.ViewPlanButton-title Mi plan de vida 
                    v-card(flat)
                        v-card-text.ViewPlanButton-card-text
                            v-layout(row)
                                v-flex(xs4)
                                    v-card.ViewPlanButton-card
                                        v-card-title Corto plazo                                        
                                        v-card-text.ViewPlanButton-short
                                            div(v-if="currentStep.data.products.filter(p => p.timeframe === 'Corto').length === 0") 
                                                v-icon(color="white" dark) sentiment_very_dissatisfied
                                                div ¡Aún no tienes ningún producto!
                                            div(v-for="product in currentStep.data.products.filter(p => p.timeframe === 'Corto')")
                                                | {{product.name}} {{product.type ? `(${product.type})`: ''}}
                                                span(v-if="product.note") - {{product.note}}
                                v-flex(xs4)
                                    v-card.ViewPlanButton-card
                                        v-card-title Mediano plazo 
                                        v-card-text.ViewPlanButton-medium
                                            div(v-if="currentStep.data.products.filter(p => p.timeframe === 'Mediano').length === 0") 
                                                v-icon(color="white" dark) sentiment_very_dissatisfied
                                                div ¡Aún no tienes ningún producto!
                                            div(v-for="product in currentStep.data.products.filter(p => p.timeframe === 'Mediano')")
                                                | {{product.name}} {{product.type ? `(${product.type})`: ''}}
                                                span(v-if="product.note") - {{product.note}}
                                v-flex(xs4)
                                    v-card.ViewPlanButton-card
                                        v-card-title Largo plazo
                                        v-card-text.ViewPlanButton-large
                                            div(v-if="currentStep.data.products.filter(p => p.timeframe === 'Largo').length === 0") 
                                                v-icon(color="white" dark) sentiment_very_dissatisfied
                                                div ¡Aún no tienes ningún producto!
                                            div(v-for="product in currentStep.data.products.filter(p => p.timeframe === 'Largo')")
                                                | {{product.name}} {{product.type ? `(${product.type})`: ''}}
                                                span(v-if="product.note") - {{product.note}}
                        v-spacer.py-3
                        el-button.ViewPlanButton-close(type="primary" @click="showDialog = false") Cerrar
                        v-spacer.py-2
        
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ViewPlanButton',
  computed: {
    ...mapGetters(['currentStep']),     
  },
  data() {
      return {
          showDialog: false          
      }
  },
}
</script>

<style scoped>
@import 'view-plan-button.scss';
</style>

